/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AppointmentSlot } from './appointmentSlot';

export type GenericApiResponseAppointmentSlotData = AppointmentSlot | null;
